<!--
 * @Author: your name
 * @Date: 2020-12-12 21:52:39
 * @LastEditTime: 2021-07-05 16:51:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-menu/components/IncreaseTab/index.vue
-->
<style scoped lang="sass">
.app_container

</style>

<style lang="sass" scoped>
$color: var(--menu-primary-text-colour)
$bgc: var(--menu-primary-background-colour)
$disabed: #c5c7c8

.dialog_title
  line-height: 1
  font-size: 17px
  margin-bottom: 25px
  color: $color
  text-align: center

.dialog_info
  line-height: 18px
  font-size: 15px
  color: $color
  text-align: center

.dialog_sub_title
  line-height: 18px
  margin-top: 20px
  margin-bottom: 45px
  font-size: 15px
  color: $color
  text-align: center

.button
  height: 56px
</style>

<template lang="pug">
.app_container
  .dialog_title.b {{ t('close_tab_now', 'Close your tab now?') }}
  .dialog_info.o6 {{ t('close_tab_confirm', 'Are you sure you want to close this tab? No further purchases will be accepted.') }}
  .dialog_sub_title.b.o8 {{ t('you_will_be_charged', 'You will be charged:') }} {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ num }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  van-button.button.b.ls1(
    @click="submit"
    type="primary"
  ) {{ t('close_tab', 'CLOSE TAB') }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  props: {
    amount: [String, Number],
    minAmount: [String, Number],
  },
  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class CLoseTab extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  submit() {
    this.$emit('closeTab')
  }

  get num() {
    const {
      amount,
      minAmount,
    } = this
    const num = amount < minAmount ? minAmount : amount
    return num ? formatDecimalNumber(parseFloat(num)) : ''
  }
}

export default CLoseTab
</script>
